<template>
  <section class="store-orders py-3" aria-label="營業所郵寄訂單">
    <p v-if="error" role="alert" class="text-danger">{{ error }} <button class="btn btn-outline-success" @click="load(page)">重試</button></p>
    <p v-else-if="loading" role="status">載入營業所郵寄訂單中…</p>
    <template v-else>
      <div v-if="orders.length" class="table-responsive">
        <table class="table table-striped table-hover text-center">
          <thead><tr><th>營業所訂單編號</th><th>訂購時間</th><th>金額合計</th><th>PV 合計</th><th>貨態</th><th>發票號碼</th><th>訂單明細</th></tr></thead>
          <tbody><tr v-for="order in orders" :key="order.id">
            <td><router-link :to="'/member/order/store/' + order.id">{{ order.order_number }}</router-link></td>
            <td>{{ formatTime(order.ordered_at) }}</td><td>{{ value(order.total_price, true) }}</td><td>{{ value(order.total_pv) }}</td><td>{{ status(order) }}</td><td>{{ order.invoice_number || '尚未提供' }}</td>
            <td><router-link class="btn btn-outline-success" :to="'/member/order/store/' + order.id">瀏覽</router-link></td>
          </tr></tbody>
        </table>
      </div>
      <p v-else class="text-center text-muted py-5">目前尚無營業所郵寄訂單貨態</p>
      <div v-if="lastPage > 1" class="d-flex justify-content-end align-items-center">
        <button class="btn btn-outline-success" :disabled="page <= 1" @click="load(page - 1)">上一頁</button>
        <span class="mx-3">第 {{ page }}／{{ lastPage }} 頁</span>
        <button class="btn btn-outline-success" :disabled="page >= lastPage" @click="load(page + 1)">下一頁</button>
      </div>
    </template>
  </section>
</template>
<script>
import { getStoreMailOrders } from '@/api/orders'
import dayjs from 'dayjs'
export default {
  data: () => ({ orders: [], page: 1, lastPage: 1, loading: false, error: '', requestId: 0 }),
  created() { this.load(1) },
  beforeDestroy() { this.requestId++ },
  methods: {
    value(v, money = false) { return v === null || v === undefined ? '尚未提供' : (money ? 'NT$ ' : '') + Number(v).toLocaleString('zh-TW') },
    formatTime(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '尚未提供' },
    status(order) { return (order.shipments || []).map(s => s.latest_status_text || '物流資料準備中').filter((v, i, a) => a.indexOf(v) === i).join('／') || '尚無貨態' },
    async load(page) {
      const id = ++this.requestId
      this.loading = true; this.error = ''; this.orders = []
      try {
        const res = await getStoreMailOrders({ page })
        if (id !== this.requestId) return
        this.orders = res.data.data; this.page = res.data.current_page; this.lastPage = res.data.last_page
      } catch (e) {
        if (id === this.requestId) this.error = '無法載入營業所郵寄訂單，請確認登入狀態及貨態查詢權限。'
      } finally { if (id === this.requestId) this.loading = false }
    }
  }
}
</script>
<style scoped>
th, td { vertical-align: middle; min-width: 100px; }
a { color: #176b50; }
</style>
